import { apiClient } from './api';
import type { UnreadCountResponse } from '@wooconnect/shared';

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const res = await apiClient.get('/notifications/unread-count');
  return res.data.data;
}

export interface NotificationPrefs {
  newOrder: boolean;
  orderStatusChanged: boolean;
  lowStock: boolean;
  refundRequest: boolean;
  productBackorder: boolean;
  dailySummary: boolean;
}

export async function getNotificationPreferences(siteId: string): Promise<NotificationPrefs> {
  const res = await apiClient.get(`/notifications/preferences/${siteId}`);
  return res.data.data;
}

export async function updateNotificationPreferences(siteId: string, prefs: Partial<NotificationPrefs>): Promise<NotificationPrefs> {
  const res = await apiClient.put(`/notifications/preferences/${siteId}`, prefs);
  return res.data.data;
}

export async function deleteAllNotifications(siteId?: string): Promise<{ deleted: number }> {
  const params = siteId ? `?siteId=${siteId}` : '';
  const res = await apiClient.delete(`/notifications/all${params}`);
  return res.data.data;
}
